/**
 * Created by Alican Köker on 2019-03-20.
 */
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EdisonParsedGameData} from "../../server/data/EdisonParsedGameData";
import {EdisonGameModuleConfig} from "../../EdisonGameModuleConfig";
import {EdisonGameMode} from "../../gameMode/EdisonGameMode";
import {TimelineLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {EdisonParsedInitData} from "../../server/data/EdisonParsedInitData";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";

export class EdisonRespinController extends BaseController {

    private _isRestore:boolean = false;
    private _gameData:EdisonParsedGameData | EdisonParsedInitData;

    constructor() {
        super();

        this.addEventListeners();
    }

    protected onGameDataParsed(data:EdisonParsedGameData | EdisonParsedInitData):void {
        this._gameData = data;
        if(data instanceof EdisonParsedInitData) {
            this._isRestore = data.isRestoreState;
        }
        else
            this._isRestore = false;
    }

    private onSpinStart():void {

    }

    public startRespinFeature():void {
        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            EdisonGameModuleConfig.background.currentMode = EdisonGameMode.STACKED_RESPIN;
        }, 1);
    }

    public activateRespinOverlay(symbol:string, reelIndex:number):void {
        EdisonGameModuleConfig.respinOverlay.playOverlay(symbol, reelIndex);
    }

    public reset():void {
        EdisonGameModuleConfig.respinOverlay.removeOverlay();
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.START, (event:GameEvent) => this.onSpinStart());
    }
}